import generatePicker, {
  PickerDateProps,
  RangePickerDateProps,
} from "antd/es/date-picker/generatePicker";
import "antd/es/date-picker/style/index";
import dayjs, { Dayjs } from "dayjs";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import React from "react";

import { useTranslation } from "react-i18next";
import { localeObjectSerbianDayjs } from "../../locale/antLocales";

// eslint-disable-next-line no-var, @typescript-eslint/no-var-requires
var updateLocale = require("dayjs/plugin/updateLocale");

dayjs.extend(updateLocale);

// antd date picker uses momentjs by default, this way we configure it to use dayjs which is easier lib

export interface DatePickerProps extends PickerDateProps<Dayjs> {
  name: string;
}

export interface RangePickerProps extends RangePickerDateProps<Dayjs> {
  name: string;
}

const DayjsDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  const { t } = useTranslation();
  //@ts-ignore
  dayjs.updateLocale("en", localeObjectSerbianDayjs(t));
  return <DayjsDatePicker {...props} data-test={`date-picker-${props.name}`} />;
};

export const RangePicker: React.FC<RangePickerProps> = (props) => {
  const { t } = useTranslation();
  //@ts-ignore
  dayjs.updateLocale("en", localeObjectSerbianDayjs(t));
  return (
    <DayjsDatePicker.RangePicker
      {...props}
      data-test={`range-picker-${props.name}`}
    />
  );
};
